<script>
import Layout from '@layouts/main.vue'
import texts from '../../assets/data/localisations.json'
import contactInfo from '../../assets/data/contact-info.json'

export default {
  components: { Layout },
  data() {
    return {
      userMessage: '',
      keyboardActive: false,
      showMessageErrorMessage: false,
      showContactTypeErrorMessage: false,
      showContactInputErrorMessage: false,
      showTimeoutMessage: false,
      showSuccessMessage: false,
      texts: null,
      messageTimeout: false,
      messageTimeoutMs: 30000,
      contactInfo: null,
      selectedContactType: '',
      contact: '',
      contactExists: false
    }
  },
  page: {
    title: 'Contact',
    meta: [{ name: 'description', content: 'The Contact page.' }],
  },
  computed: {
    consentPopup() {
      return this.$store.getters['globals/consentPopup']
    },
    allMessages() {
      return this.$store.getters['topics/allMessages']
    },
    allTopics() {
      return this.$store.getters['topics/filteredTopics']
    },
    locale() {
      return this.$store.getters['globals/locale']
    },
    platform() {
      return this.$store.getters['globals/platform']
    },
    params() {
      return this.$store.getters['globals/params']
    },
    messageResponse() {
      return this.$store.getters['topics/getMessageResponse']
    },
    hyperdotApp() {
      return this.$store.getters['globals/hyperdotApp']
    },
    sa2App() {
      return this.$store.getters['globals/sa2App']
    },
  },
  watch: {
    allMessages(val) {
      // refresh allMessages list when new messages are incoming
      this.generateConversationDisplay()
      this.checkForExistingContact(this.allMessages.filter(message => message.userGenerated))
    },
    keyboardActive(val) {
      this.scrollToBottom()
    },
    userMessage(val) {
      if (this.locale === 'zh-csm') this.showMessageErrorMessage = false
      else if ((val.split(' ').length > 9 && val.length > 18) || val.length === 0) {
        this.showMessageErrorMessage = false
      } else {
        this.showMessageErrorMessage = true
      }
    },
    selectedContactType(val) {
      if (val) this.showContactTypeErrorMessage = false
      else if (!val && this.contact.length > 0) this.showContactTypeErrorMessage = true
    },
    contact(val) {
      if (val.length >= 100) {
        this.showContactInputErrorMessage = true
      } else {
        this.showContactInputErrorMessage = false
      }

      if (val.length > 0 && !this.selectedContactType) {
        this.showContactTypeErrorMessage = true
      } else {
        this.showContactTypeErrorMessage = false
      }
    },
    messageResponse(val) {
      // watch for message response change and trigger the show success dialog
      if (val.ok !== null) {
        this.showSuccessMessage = true
      }
      // handle delivery not succedded label
      if (val.ok === false) {
        this.$store.dispatch('topics/lastMessageNotSent', this.allMessages)
      }
    },
    showSuccessMessage(val) {
      if (val === false)
        this.$store.dispatch('topics/resetMessageResponse', null)
    },
  },
  created() {
    this.texts = texts
    this.contactInfo = contactInfo
  },
  mounted() {
    if (this.sa2App) this.$router.push('/')
    // initialise message list
    this.generateConversationDisplay()
    this.checkForExistingContact(this.allMessages.filter(message => message.userGenerated))
  },
  methods: {
    discordConsent() {
      this.$router.push({ name: 'discord-consent' })
    },
    isAndroid() {
      if (this.platform !== undefined)
        if (this.platform.includes('Android')) return true
      if (/Android/i.test(navigator.userAgent)) return true
      return false
    },
    scrollToBottom() {
      console.log('scroll')
      this.$nextTick(() => {
        if (document.getElementById('appcontent')) {
          document
            .getElementById('appcontent')
            .scrollTo(0, document.getElementById('appcontent').scrollHeight)
        }
      })
    },
    resetUnreadCount(val) {
      this.$store.dispatch('globals/resetUnread', val)
    },
    setMessageTimeout() {
      this.messageTimeout = true
      setTimeout(() => {
        this.messageTimeout = false
        this.showTimeoutMessage = false
      }, this.messageTimeoutMs)
    },
    sendMessage() {
      if (this.messageTimeout) this.showTimeoutMessage = true
      else if (this.locale === 'zh-csm') {
        // Chinese store mode on submit check
        if (this.userMessage.length > 0) {
          if (!this.selectedContactType && this.contact.length > 0) this.showContactTypeErrorMessage = true
          else if (this.selectedContactType && this.contact.length > 0) {
            this.userMessage = '[' + this.selectedContactType + ']' + '<br />' + this.contact + '<br />' + this.userMessage
            this.dispatchMessage(this.userMessage, true, false)
            this.userMessage = ''
            this.selectedContactType = ''
            this.contact = ''
            this.showMessageErrorMessage = false
            this.setMessageTimeout()
          } else {
            this.dispatchMessage(this.userMessage, true, false)
            this.userMessage = ''
            this.selectedContactType = ''
            this.contact = ''
            this.showMessageErrorMessage = false
            this.setMessageTimeout()
          }
        } else {
          this.showMessageErrorMessage = true
        }
      } else {
        // Simple check to ensure a coherent text is entered (at least 10 words - not exact science, but close!)
        // We do this check only for first message sent, for other we just require a minimal standard of 2 characters (allowing replies like "OK")
        if (this.allMessages.length <= 1) {
          if (
            this.userMessage.split(' ').length > 9 &&
            this.userMessage.length > 18
          ) {
            this.dispatchMessage(this.userMessage, true, false)
            this.userMessage = ''
            this.showMessageErrorMessage = false
            this.setMessageTimeout()
          } else {
            this.showMessageErrorMessage = true
          }
        } else {
          this.dispatchMessage(this.userMessage, true, false)
          this.userMessage = ''
          this.showMessageErrorMessage = false
          this.setMessageTimeout()
        }
      }
    },
    dispatchMessage(message, ug, isLocal) {
      // messages that are 'pushed' were sent to support, but we don't have the confirmation yet that they were received.
      // pushed messages are only stored in the display queue and will be overwritten when we receive a new conversation list from the server
      // non-pushed messages are local messages which are not sent to server and are stored only for this session. These messages will be displayed throughout the session.
      this.$store.dispatch('topics/postLocalMessage', {
        body: message,
        userGenerated: ug,
        local: isLocal,
      })
      if (ug) {
        this.$store.dispatch('topics/postMessage', {
          body: message.replace(/<br[^>]*>/gi, '\n'),
        })
      }
    },
    // join and sort local and server supplied messages by timestamp
    generateConversationDisplay() {
      // this.messageList = this.allMessages
      console.log(this.allMessages)
      this.markMessagesAsRead()
      this.scrollToBottom()
    },
    markMessagesAsRead() {
      // get last message timestamp (check server retrieved messages only, to prevent possible bad requests with local messages)
      if (this.allMessages.length > 0) {
        if (
          this.allMessages[this.allMessages.length - 1].createdAt &&
          !this.allMessages[this.allMessages.length - 1].messageRead
        ) {
          this.$store.dispatch(
            'topics/markAsRead',
            this.allMessages[this.allMessages.length - 1].createdAt
          )
          this.resetUnreadCount(0)
        }
      }
    },
    checkForExistingContact(messages) {
      const contactInfoLocale = this.contactInfo[this.locale];

      // contactInfoLocale will only be populated in case of 'zh-csm'
      // for all other languages we return early.
      if (!contactInfoLocale || !contactInfoLocale.types) {
        return;
      }
      const contactInfoTypes = Object.keys(this.contactInfo[this.locale].types)
      // Check if any of user generated messages contains any of the contact types
      this.contactExists = messages.some(message => {
        return contactInfoTypes.some(contactInfoType => {
          return message.body.includes('[' + this.contactInfo[this.locale].types[contactInfoType] + ']')
        })
      })
    }
  },
}
</script>

<template>
  <Layout>
    <div class="chat-container">
      <div v-if="allMessages.length > 0" class="conversation-container">
        <template v-for="(message, index) in allMessages">
          <div
            v-if="(!consentPopup || !message.local) && !message.consentPopupType
              "
            :key="index"
            :class="[
              'message',
              message.userGenerated ? 'card-right' : 'card-left',
              message.error ? 'error' : '',
            ]"
          >
            <md-avatar v-if="!message.userGenerated" class="md-avatar-icon">
              <svg class="md-icon" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40"><path d="m465.334-32-3.333-137L429-170q-147.333-13.667-247.166-123.167Q82-402.667 82-551q0-158.604 111.919-269.302Q305.837-931 464.946-931q78.387 0 146.349 29.262 67.961 29.262 118.424 80.425 50.463 51.164 79.705 120.504 29.242 69.34 29.242 149.809 0 81.333-28.666 157.166Q781.333-318 731.167-251.5 681-185 612.667-129.334 544.334-73.667 465.334-32Zm-.001-281.333q21 0 35.5-14.5t14.5-35.166q0-20.667-14.5-35.167t-35.5-14.5q-20.999 0-35.499 14.5-14.5 14.5-14.5 35.167 0 20.666 14.5 35.166 14.5 14.5 35.499 14.5ZM426.667-454h73.444q0-26.926 8.778-44.629 8.778-17.704 32.778-41.037 25.333-26.001 37.166-48.001 11.834-22 11.834-50.825 0-51.921-32.5-82.714Q525.667-752 469.334-752q-46.667 0-83.056 27.861-36.389 27.861-52.611 71.472L402.328-625q9.672-24 26.178-39t36.827-15q24.001 0 37.334 11.282Q516-656.436 516-637.697q0 15.03-10.833 32.03-10.833 17.001-30.5 37.334-30.667 30-39.333 50.584-8.667 20.583-8.667 63.749Z"/></svg>
            </md-avatar>
            <md-card class="card">
              <md-card-content v-html="message.body"></md-card-content>
            </md-card>
            <div v-if="message.error" class="messagenotsent">{{
              texts[locale].notsent
            }}</div>
          </div>
          <div
            v-if="message.consentPopupType"
            :key="index + 'consent'"
            :class="[
              message.userGenerated ? 'card-right' : 'card-left',
              message.error ? 'error' : '',
              'message',
              'consent',
              message.consentPopupType,
            ]"
          >
            <md-avatar v-if="!message.userGenerated" class="md-avatar-icon">
              <svg class="md-icon" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40"><path d="m465.334-32-3.333-137L429-170q-147.333-13.667-247.166-123.167Q82-402.667 82-551q0-158.604 111.919-269.302Q305.837-931 464.946-931q78.387 0 146.349 29.262 67.961 29.262 118.424 80.425 50.463 51.164 79.705 120.504 29.242 69.34 29.242 149.809 0 81.333-28.666 157.166Q781.333-318 731.167-251.5 681-185 612.667-129.334 544.334-73.667 465.334-32Zm-.001-281.333q21 0 35.5-14.5t14.5-35.166q0-20.667-14.5-35.167t-35.5-14.5q-20.999 0-35.499 14.5-14.5 14.5-14.5 35.167 0 20.666 14.5 35.166 14.5 14.5 35.499 14.5ZM426.667-454h73.444q0-26.926 8.778-44.629 8.778-17.704 32.778-41.037 25.333-26.001 37.166-48.001 11.834-22 11.834-50.825 0-51.921-32.5-82.714Q525.667-752 469.334-752q-46.667 0-83.056 27.861-36.389 27.861-52.611 71.472L402.328-625q9.672-24 26.178-39t36.827-15q24.001 0 37.334 11.282Q516-656.436 516-637.697q0 15.03-10.833 32.03-10.833 17.001-30.5 37.334-30.667 30-39.333 50.584-8.667 20.583-8.667 63.749Z"/></svg>
            </md-avatar>
            <md-card class="card">
              <md-card-content>
                <p
                  ><strong
                    >A Legend Like YOU <br />needs to be Part of the
                    Community!</strong
                  ></p
                >
                <p
                  >You’ve conquered the arena, now it’s time for
                  <strong>YOU</strong> to share your battle prowess! <br /><em
                    >Join our Discord channel and help shape our growing
                    community.</em
                  >
                  Discuss strategy, take part in giveaways and share your
                  feedback to make the game we all love even better.
                  <br /><strong>Simply click the link below</strong> and share
                  your Discord username
                  <strong
                    >to receive an EXCLUSIVE DISCORD RANK that will mark you as
                    a true Legend.</strong
                  ></p
                >
                <div
                  class="gotodiscord"
                  @click="discordConsent"
                  @touch="discordConsent"
                  >Join Now</div
                >
              </md-card-content>
            </md-card>
            <div v-if="message.error" class="messagenotsent">{{
              texts[locale].notsent
            }}</div>
          </div>
        </template>

        <div class="clear"></div>
      </div>
      <div v-else>
        <div class="loading">
          <span class="loadingmessage">{{ texts[locale].chathistory }}</span>
          <md-progress-spinner
            :md-diameter="80"
            :md-stroke="6"
            md-mode="indeterminate"
          ></md-progress-spinner>
        </div>
      </div>

      <div class="chat-input">
        <p v-if="texts[locale].problemDescription && texts[locale].problemDescription.length > 0"
           class="heading">{{ texts[locale].problemDescription }}</p>
        <md-field :class="showMessageErrorMessage ? 'md-invalid' : ''">
          <label>{{ texts[locale].yourmessage }}</label>
          <md-textarea v-model="userMessage"></md-textarea>
          <span class="md-error">{{ texts[locale].moredescriptive }}</span>
        </md-field>

        <template v-if="!contactExists && contactInfo[locale] && contactInfo[locale].types && Object.keys(contactInfo[locale].types).length > 0">
          <p v-if="texts[locale].contactInformation && texts[locale].contactInformation.length > 0"
             class="heading">{{ texts[locale].contactInformation }}</p>
          <div class="contact">
            <md-field class="contact__type"
                      :class="showContactTypeErrorMessage ? 'md-invalid' : ''">
              <label for="contact-type">{{ contactInfo[locale].label }}</label>
              <md-select id="contact-type" v-model="selectedContactType" name="contact-type">
                <md-option v-if="selectedContactType && selectedContactType.length > 0" value="">{{ contactInfo[locale].label }}</md-option>
                <md-option v-for="contactType in contactInfo[locale].types"
                           :key="contactType"
                           :value="contactType">{{ contactType }}</md-option>
              </md-select>
              <span class="md-error">{{ contactInfo[locale].typeErrorMessage }}</span>
            </md-field>
            <md-field class="contact__input"
                      :class="showContactInputErrorMessage ? 'md-invalid' : ''"
                      :md-counter="false">
              <md-input v-model="contact" maxlength="100"></md-input>
              <span class="md-error">{{ contactInfo[locale].inputErrorMessage }}</span>
            </md-field>
          </div>
        </template>

        <p v-if="texts[locale].disclaimer && texts[locale].disclaimer.length > 0" class="disclaimer" v-html="texts[locale].disclaimer"></p>

        <span v-if="showTimeoutMessage"
              class="timeout-notice">{{ texts[locale].timeoutMessage }}
        </span>
        <md-button
          class="md-raised md-primary"
          @click="sendMessage"
          >{{ texts[locale].submit }}</md-button
        >
        <div v-if="isAndroid()" class="android-toolbarfix"></div>
        <div class="clear"></div>
      </div>
      <div v-if="isAndroid()" class="dummy-keyboard"></div>
    </div>
    <md-dialog
      id="message-sent"
      :md-fullscreen="false"
      :md-active.sync="showSuccessMessage"
    >
      <md-dialog-title>{{ messageResponse.title }}</md-dialog-title>
      <span v-if="messageResponse.ok" class="md-icon success">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#00e676" height="48" viewBox="0 -960 960 960" width="48"><path d="M378-232.434 140.434-470l57.131-57.131L378-346.696l383.435-383.435L818.566-673 378-232.434Z"/></svg>
      </span>
      <span v-else class="md-icon error">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#e62e00" height="48" viewBox="0 -960 960 960" width="48"><path d="M479.854-265.869q19.798 0 32.69-12.462 12.891-12.463 12.891-32.262 0-19.798-12.745-32.973-12.745-13.174-32.544-13.174-19.798 0-32.69 13.157-12.891 13.156-12.891 32.955t12.745 32.279q12.745 12.48 32.544 12.48Zm-36.463-166.566h79.218v-262.609h-79.218v262.609Zm36.953 366.566q-86.203 0-161.506-32.395-75.302-32.395-131.741-88.833-56.438-56.439-88.833-131.738-32.395-75.299-32.395-161.587 0-86.288 32.395-161.665t88.745-131.345q56.349-55.968 131.69-88.616 75.34-32.648 161.676-32.648 86.335 0 161.779 32.604t131.37 88.497q55.926 55.893 88.549 131.452 32.623 75.559 32.623 161.877 0 86.281-32.648 161.575-32.648 75.293-88.616 131.478-55.968 56.186-131.426 88.765-75.459 32.58-161.662 32.58Zm.156-79.218q139.239 0 236.826-97.732 97.587-97.732 97.587-237.681 0-139.239-97.4-236.826-97.399-97.587-237.796-97.587-139.021 0-236.826 97.4-97.804 97.399-97.804 237.796 0 139.021 97.732 236.826 97.732 97.804 237.681 97.804ZM480-480Z"/></svg>
      </span>

      <div class="ms-text">{{ messageResponse.message }}</div>
      <md-dialog-actions>
        <md-button
          class="md-primary md-raised"
          @click="showSuccessMessage = false"
          >{{ texts[locale].backtosupport }}</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </Layout>
</template>

<style lang="scss">
.back-button {
  font-weight: bold;
  font-size: 20px;

  // span {
  //   margin-left: 20px;
  // }
}

.chat-container {
  width: 100%;

  .loading {
    margin-top: 20%;

    .loadingmessage {
      display: block;
      margin: 0 auto;
      width: auto;
      text-align: center;
    }

    >div {
      left: 50%;
      margin-top: 30px;
      margin-left: -40px;
    }
  }

  .conversation-container {
    position: relative;
    width: 100%;
    padding: 0 20px;
    margin-top: 10px;

    .messagenotsent {
      width: 80%;
      margin: 5px 0;
      font-size: 12px;
      color: #666;
      text-align: right;
      float: right;
    }

    .message {
      width: 80%;
      margin: 5px 0;
      position: relative;

      .md-avatar-icon {
        display: inline-block;
        vertical-align: top;
        margin: 5px 10px 0 0;
        width: 24px;
      }

      .card {
        display: inline-block;
        border-radius: 10px;
        position: relative;

        .md-card-content {
          padding: 16px !important;
          word-break: break-word;

          div {
            word-break: break-word;
          }

          span {
            word-break: break-word;
          }

          p {
            margin: 0;
            word-break: break-word;
          }

          a {
            word-break: break-all;
          }
        }
      }

      &.card-left {
        float: left;

        .card {
          background-color: #e3f2fd;
          width: calc(100% - 54px);
        }
      }

      &.card-right {
        float: right;
        width: 70%;

        .card {
          background-color: #1e88e5;
          color: #fff;
          width: 100%;
        }

        a {
          color: #fff;
          text-decoration: underline;
        }
      }

      &.error {
        .card {
          background-color: #fc6c6c;
        }
      }

      &.consent {
        .card {
          margin-top: 28%;

          .md-card-content {
            padding: 0 16px 20px 16px !important;
          }

          p {
            text-align: center;
            margin-bottom: 10px;
          }

          .gotodiscord {
            text-indent: -9999px;
            margin: 0 auto;
            width: 100%;
            max-width: 150px;
            height: 45px;
            background-image: url('../../assets/images/ml_vip_cta.png');
            background-repeat: no-repeat;
            background-size: contain;

            @media screen and (min-width: 400px) {
              max-width: 190px;
              height: 55px;
            }

            @media screen and (min-width: 500px) {
              max-width: 200px;
              height: 60px;
            }
          }

          &::before {
            content: ' ';
            position: relative;
            display: block;
            margin-top: -32%;
            width: 100%;
            height: 0;
            padding-bottom: 41%;
            background-image: url('../../assets/images/ml_vip_header.png');
            background-repeat: no-repeat;
            background-size: contain;
            z-index: 100;
          }
        }
      }
    }
  }

  .chat-input {
    position: relative;
    width: 100%;
    padding: 10px 20px;
    display: grid;
    grid-template-rows: auto auto;
    justify-items: left;
    align-items: center;

    .heading {
      font-weight: bold;
      margin-bottom: 0;
    }

    .contact {
      display: flex;
      flex-wrap: wrap;
      column-gap: 1rem;
      width: 100%;

      &__type {
        max-width: 100%;

        @media screen and (min-width: 375px) {
          max-width: 33%;
        }
      }

      &__input {
        max-width: 100%;

        @media screen and (min-width: 375px) {
          max-width: calc(67% - 1rem);
        }
      }
    }

    button {
      margin: 6px 0;
    }

    .md-field {
      margin: 4px 0 20px;
      padding-top: 25px;
    }

    .android-toolbarfix {
      height: 50px;
      width: 100%;
    }

    .timeout-notice {
      display: block;
      opacity: 1;
      transform: translateZ(0);
      color: #ff1744;
      height: 20px;
      bottom: -22px;
      font-size: 12px;
      transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  .dummy-keyboard {
    height: 50vh;
  }
}

#message-sent {
  .md-title {
    font-size: 17px;
    text-align: center;
  }

  .md-icon {
    width: 50px;
    min-width: 50px;
    height: 50px;
    font-size: 50px !important;

    &.success {
      color: #00e676;
    }

    &.error {
      color: #e62e00;
    }
  }

  .ms-text {
    padding: 10px 15px;
    text-align: center;
  }
}

.clear {
  clear: both;
}

.ar .chat-container .conversation-container .message .md-avatar-icon {
  margin: 5px 0 0 10px;
}

.disclaimer {
  margin-top: 2rem;
  font-weight: 600;
}
</style>
